<template>
  <div class="page-header">
    <div class="page-header__lead">
      <Breadcrumb
        v-if="breadcrumb"
        :items="items"
      />
      <div
        v-if="title"
        class="flex items-center gap-4"
      >
        <h1 class="text-2xl font-semibold leading-7 sm:text-3xl sm:tracking-tight">
          {{ title }}
        </h1>
        <slot name="title-append"></slot>
      </div>
      <div
        v-if="description"
        class="text-md text-tertiary"
      >
        {{ description }}
      </div>
    </div>
    <div
      v-if="$slots.right"
      class="page-header__actions"
    >
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import Breadcrumb from '@/components/page/Breadcrumb.vue'

defineProps({
  align: {
    type: String,
    default: 'left' // center, left
  },
  title: {
    type: String,
    default: null
  },
  description: {
    type: String,
    default: null
  },
  breadcrumb: {
    type: Boolean,
    default: false
  },
  items: {
    type: Array,
    default: () => []
  }
})
</script>

<style scoped>
.page-header {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--s-3);
  margin-bottom: var(--s-4);
}

.page-header__lead {
  display: flex;
  flex-direction: column;
  gap: var(--s-2);
  justify-content: center;
  min-width: 0;
}

.page-header__actions {
  display: flex;
  justify-content: flex-end;
  min-width: 0;
  width: 100%;
}

@media (min-width: 1024px) {
  .page-header {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: var(--s-6);
  }

  .page-header__actions {
    width: auto;
    flex: 0 1 auto;
    justify-content: flex-end;
  }
}
</style>
